import clsx from "clsx";
import { useBudouX } from "@/hooks/useBudouX";

export const VoiceCover = ({ className, title, avatar }) => {
  const { parse } = useBudouX();
  return (
    <>
      <div
        className={clsx(
          className,
          "mx-auto flex max-w-2xl flex-col gap-2 px-8 text-txt-base md:gap-6"
        )}
      >
        <h4 className="font-bold fluid-text-[11px,18px]">
          Voices - メンバーの声
        </h4>
        <h2 className="font-bold leading-snug fluid-text-[18px,45px]">
          {parse(`${title}`)}
        </h2>
        <h5 className="font-bold fluid-text-[14px,18px]">{avatar}</h5>
      </div>
    </>
  );
};
